import axios from "axios";

/**
 * Saves data to the API and updates the status in the parent component.
 *
 * @param {string} pageName - The name of the page being saved.
 * @param {Object} data - The data to be saved (JSON format).
 * @param {Function} setStatus - Function to update status messages.
 *
 * @example
 * saveData( data, setStatus);
 */
export async function saveData(apiPath, data, setStatus) {
    const API_URL = process.env.NODE_ENV === "development"
        ? "http://localhost:3000/"
        : "https://api.hillerodfrimenighed.dk/";


    try {
        setStatus("Saving...");

        await axios.post(`${API_URL}${apiPath}`, 
            {  
                data,         
            }, 
            {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });

        setStatus("Data updated successfully!");
    } catch (error) {
        console.error("Save error:", error);
        setStatus(`Error: ${error.response?.data?.error || "Failed to update."}`);
    }
}
